import React from "react";
import desktop from "../assets/images/desktop.svg"

 export const BackgroundImage = () => {
    return (
        <img className="" src={desktop} style={{width: `100%`}} />
    )
}

